import { render, staticRenderFns } from "./historyOrder.vue?vue&type=template&id=4f182f3d&scoped=true&"
import script from "./historyOrder.vue?vue&type=script&lang=ts&"
export * from "./historyOrder.vue?vue&type=script&lang=ts&"
import style0 from "./historyOrder.vue?vue&type=style&index=0&id=4f182f3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f182f3d",
  null
  
)

export default component.exports